import React from 'react';
import telescop from '../../../images/telescop.jpg'
import tele from '../../../images/tele.jpg'

const Special = () => {
    return (
        <div className='container'>
            <h1 className='mb-4 mt-5 pt-5 text-info'> Ramadan Special Service</h1>

            <div className='d-flex justify-content-center'>
                <div>
<img className='img-fluid' src={telescop}/>

                </div>
                <div>
                <img  className='img-fluid' style={{height:"480px"}} src={tele}/>
                </div>
                
            </div>
            <h2 className='text-warning fw-bold'>We near you</h2>
<p className='fw-bold fs-5'>Exoplanet Photography is one of the best astrophotography service in the world.It serves a lot of facility for consumer reasonable price.You will be happy that to know in Ramadan we offer you telescope to your home.If you want to see planet,nebula,star from your home please contact us.We provide a lot of facility with professional instruction for your satisfaction.Stay with us.</p>
        </div>
    );
};

export default Special;